export default __webpack_public_path__ + "static/radisson-blu-dfd6b0833d7170e663a22f4db860b4f6.svg";